import React from 'react';
import CrossIcon from '../atoms/CrossIcon';
const SizeGuideModal = ({ modalOpen, templateCopy, closeModal }) => {
    return (React.createElement("div", { className: `th-c-atc-modal ${modalOpen ? 'open' : ''}` },
        React.createElement("div", { className: "th-c-atc-modal__background", onClick: closeModal }),
        React.createElement("div", { className: "th-c-atc-modal__inner" },
            React.createElement("div", { className: "th-c-atc-modal__header" },
                React.createElement("h3", { className: "th-customiser__section-title" }, templateCopy.th_c_size_guide_button),
                React.createElement("button", { className: "th-c-atc-modal__close", "aria-label": "close", onClick: closeModal },
                    React.createElement(CrossIcon, null))),
            React.createElement("div", { className: "th-c-atc-modal__main th-c-atc-modal__main--size-guide" },
                React.createElement("div", { className: "prose", dangerouslySetInnerHTML: { __html: templateCopy.th_c_size_guide_content } })))));
};
export default SizeGuideModal;
